import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  InputNumber,
  Button,
  Upload,
  message,
  Select,
  Typography,
  Row,
  Col,
  Alert,

} from 'antd';
import { ShoppingOutlined, InboxOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Dragger } = Upload;
const { Option } = Select;
const { Title } = Typography;

const CrearProducto = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [talles, setTalles] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [colores, setColores] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [loadingMarcas, setLoadingMarcas] = useState(false);
  const [loadingTalles, setLoadingTalles] = useState(false);
  const [loadingGeneros, setLoadingGeneros] = useState(false);
  const [loadingColores, setLoadingColores] = useState(false);
const [categoriaSeleccionado, setCategoriaSeleccionado] = useState(null);
const [usuarioId, setUsuarioId] = useState(null);
console.log(usuarioId)

  useEffect(() => {
    const id = localStorage.getItem('usuarioId');
    setUsuarioId(id);
  }, []);

  useEffect(() => {
    if (!usuarioId) return;

    const fetchCategorias = async () => {
      setLoadingCategorias(true);
      try {
        const res = await axios.get('https://elarigestion-production.up.railway.app/api/categorias', {
          params: { usuarioId },
        });
        setCategorias(res.data);
      } catch (err) {
        console.error('Error al cargar categorías', err);
        message.error('No se pudieron cargar las categorías');
        setCategorias([]);
      } finally {
        setLoadingCategorias(false);
      }
    };

    const fetchMarcas = async () => {
      setLoadingMarcas(true);
      try {
        const res = await axios.get('https://elarigestion-production.up.railway.app/api/marcas', {
          params: { usuarioId },
        });
        setMarcas(res.data);
      } catch (err) {
        console.error('Error al cargar marcas', err);
        message.error('No se pudieron cargar las marcas');
        setMarcas([]);
      } finally {
        setLoadingMarcas(false);
      }
    };

    const fetchTalles = async () => {
      setLoadingTalles(true);
      try {
        const res = await axios.get('https://elarigestion-production.up.railway.app/api/talles', {
          params: { usuarioId },
        });
        setTalles(res.data);
      } catch (err) {
        console.error('Error al cargar talles', err);
        message.error('No se pudieron cargar los talles');
        setTalles([]);
      } finally {
        setLoadingTalles(false);
      }
    };

    const fetchGeneros = async () => {
      setLoadingGeneros(true);
      try {
        const res = await axios.get('https://elarigestion-production.up.railway.app/api/generos', {
          params: { usuarioId },
        });
        setGeneros(res.data);
      } catch (err) {
        console.error('Error al cargar géneros', err);
        message.error('No se pudieron cargar los géneros');
        setGeneros([]);
      } finally {
        setLoadingGeneros(false);
      }
    };

    const fetchColores = async () => {
      setLoadingColores(true);
      try {
        const res = await axios.get('https://elarigestion-production.up.railway.app/api/colores',);
        setColores(res.data);
      } catch (err) {
        console.error('Error al cargar colores', err);
        message.error('No se pudieron cargar los colores');
        setColores([]);
      } finally {
        setLoadingColores(false);
      }
    };

    fetchCategorias();
    fetchMarcas();
    fetchTalles();
    fetchGeneros();
    fetchColores();
  }, [usuarioId]);

  const onFinish = async (values) => {
    setSubmitLoading(true);
    const token = localStorage.getItem('token');

    const formData = new FormData();
    formData.append('nombre', values.nombre);
    formData.append('descripcion', values.descripcion);
    formData.append('precio', values.precio);
    formData.append('stock', values.stock);
    formData.append('usuarioId', usuarioId);
    formData.append('categoriaId', values.categoriaId);
    formData.append('marcaId', values.marcaId);
    formData.append('talleIds', JSON.stringify(values.talleIds));

    formData.append('generoId', values.generoId);
    formData.append('colorIds', JSON.stringify(values.colorIds));

    if (fileList.length > 0) {
      formData.append('file', fileList[0]);
    }

    try {
      await axios.post('https://elarigestion-production.up.railway.app/api/producto', formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data',
        },
      });
      message.success('✅ Producto creado correctamente');
      form.resetFields();
      setSuccessMessage('Producto guardado correctamente');

      setFileList([]);
    } catch (err) {
      console.error(err);
      const msg = err.response?.data?.message || err.message || 'Error desconocido';
      setErrorMessage(msg);
    } finally {
      setSubmitLoading(false);
    }
  };
  const uploadProps = {
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    onRemove: () => setFileList([]),
    fileList,
    accept: 'image/*',
    maxCount: 1,
  };
  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
        <ShoppingOutlined style={{ fontSize: 32, color: '#1890ff' }} />
        <Title level={2} style={{ margin: 0 }}>Crear Producto</Title>
      </div>
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item>
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Arrastra o haz clic para subir una imagen</p>
            <p className="ant-upload-hint">Solo se permite una imagen.</p>
          </Dragger>
        </Form.Item> 

        <Form.Item>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Nombre"
                name="nombre"
                rules={[{ required: true, message: 'Ingresa un nombre' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Categoría"
                name="categoriaId"
                rules={[{ required: true, message: 'Selecciona una categoría' }]}
              >
                <Select
                  placeholder="Selecciona una categoría"
                  loading={loadingCategorias}
                  disabled={categorias.length === 0}
onChange={(value) => {
  const categoria = categorias.find((g) => g.id === value);
  setCategoriaSeleccionado(categoria?.nombre?.toLowerCase() || null);
}}


                >
                  {categorias.map((cat) => (
                    <Option key={cat.id} value={cat.id}>
                      {cat.nombre}
                    </Option>
                  ))}
                </Select>

                
              </Form.Item>
            </Col>
            {/*   <Col span={12}>
            <Form.Item
              label="Descripción"
              name="descripcion"
              rules={[{ required: true, message: 'Ingresa una descripción' }]}
            >
              <Input.TextArea rows={3} />
            </Form.Item>
          </Col> */}
          </Row>



          <Row gutter={16}>



            <Col span={12}>

              <Form.Item
                label="Colores"
                name="colorIds"
                rules={[{ required: true, message: 'Selecciona al menos un color' }]}
              >
                <Select
                  mode="multiple"
                  placeholder="Selecciona uno o más colores"
                  loading={loadingColores}
                  disabled={colores.length === 0}
                  allowClear
                >
                  {colores.map((color) => (
                    <Option key={color.id} value={color.id}>
                      {color.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Marca"
                name="marcaId"
                rules={[{ required: true, message: 'Selecciona una marca' }]}
              >
                <Select
                  placeholder="Selecciona una marca"
                  loading={loadingMarcas}
                  disabled={marcas.length === 0}
                >
                  {marcas.map((marca) => (
                    <Option key={marca.id} value={marca.id}>
                      {marca.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
  
<Form.Item
  label="Talles"
  name="talleIds"
  rules={[{ required: true, message: 'Selecciona al menos un talle' }]}
>
  <Select
    mode="multiple"
    placeholder="Selecciona uno o más talles"
    loading={loadingTalles}
    disabled={talles.length === 0}
    allowClear
  >
    {talles
      .filter((talle) =>
        categoriaSeleccionado === 'zapatillas'
          ? talle.talles_zapas
          : talle.nombre
      )
      .map((talle) => (
        <Option key={talle.id} value={talle.id}>
          {categoriaSeleccionado === 'zapatillas'
            ? talle.talles_zapas
            : talle.nombre}
        </Option>
      ))}
  </Select>
</Form.Item>



            </Col>
            <Col span={12}>
           <Form.Item label="Género" name="generoId">
  <Select
    placeholder="Selecciona un género"
    loading={loadingGeneros}
    disabled={generos.length === 0}

  >
    {generos.map((genero) => (
      <Option key={genero.id} value={genero.id}>
        {genero.nombre}
      </Option>
    ))}
  </Select>
</Form.Item>

            </Col>
          </Row>


          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="Precio"
                name="precio"
                rules={[{ required: true, message: 'Ingresa un precio' }]}
              >
                <InputNumber style={{ width: '100%' }} min={0} step={0.01} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Stock"
                name="stock"
                rules={[{ required: true, message: 'Ingresa el stock' }]}
              >
                <InputNumber style={{ width: '100%' }} min={0} />
              </Form.Item>
            </Col>
          </Row>
          {errorMessage && (
            <Alert
              description={errorMessage}
              type="error"
              showIcon
              closable
              onClose={() => setErrorMessage(null)}
              style={{ marginBottom: 16 }}
            />
          )}

          {successMessage && (
            <Alert
              description={successMessage}
              type="success"
              showIcon
              closable
              onClose={() => setSuccessMessage(null)}
              style={{ marginBottom: 16 }}
            />
          )}

          <Button type="primary" htmlType="submit" loading={submitLoading} block>
            Crear Producto
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CrearProducto;
